import { BadgeProps } from '@commenda/kakashi/src/components/Badge';
import { WorkflowTemplateVersionStatus } from '@prisma/client';

export class WorkflowTemplateHelper {
  static WorkflowTemplateVersionStatusBadgeVariantMap: Record<
    WorkflowTemplateVersionStatus,
    {
      variant: BadgeProps['variant'];
      text: string;
    }
  > = {
    [WorkflowTemplateVersionStatus.DRAFT]: {
      variant: 'gray',
      text: 'Draft',
    },
    [WorkflowTemplateVersionStatus.PUBLISHED]: {
      variant: 'success',
      text: 'Published',
    },
    [WorkflowTemplateVersionStatus.DEPRECATED]: {
      variant: 'warning',
      text: 'Deprecated',
    },
  };
}
